var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGmailLogo = function SvgGmailLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 34"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gmailLogo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M8.006 33.04V16.318l-3.91-4.745L.59 8.94v21.15c0 1.632.997 2.95 2.225 2.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M25.805 33.041h5.19c1.232 0 2.226-1.323 2.226-2.951V8.941l-3.972 3.016-3.444 4.362z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "m8.005 16.318-.532-6.534.532-6.254 8.899 8.853 8.899-8.853.595 5.916-.595 6.872-8.9 8.853z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M25.805 3.53v12.788l7.416-7.377V5.006c0-3.65-3.141-5.73-5.34-3.541z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5221F",
    d: "M.59 8.94 4 12.335l4.006 3.984V3.531L5.929 1.465C3.727-.724.59 1.357.59 5.006z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gmailLogo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.59.571h32.63v32.63H.59z"
  })))));
};
export default SvgGmailLogo;